<template>
  <div class="overlay">
    <div
      class="upload-image-wrapper"
      style="width: 45em; height: 30em; overflow: auto"
    >
    <div class="close"><button v-on:click="close">X</button></div>
      <span>
        <select
          v-model="selectOption"
          class="browser-default"
          style="width: 30%; display: inline-block; margin-left: -12rem"
        >
          <!-- <option value="" disabled selected>Select Option</option> -->
          <option value="addInstance">Add Instances</option>
          <!-- <option value="allInstances" disabled selected>All Instances</option>
          <option value="ThisInstance" disabled selected>This Instance</option> -->
        </select>
      </span>
      <span>
        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<b>
          Visible For :
        </b>
      </span>
      <div class="row" style="height: 21em; overflow: auto">
        <div class="col s7">
          <div v-if="selectOption === 'addInstance'">
            <p class="left-align">
              <span
                class="add-hover suggestion-list-add"
                v-for="(suggestion, index) in hiddenForInstance"
                :key="index"
                @click="addInstance(index, suggestion)"
              >
                {{ suggestion }}
              </span>
            </p>
          </div>
        </div>
        <div class="seperator"></div>
        <div class="col s5">
          <div v-if="selectOption === 'addInstance'">
            <ul class="suggestion-list-remove">
              <li v-for="(suggestion, index) in visibleForInstance" :key="index" style="display: flex">
                <span class="add-box" @click="removeInstance(index, suggestion)">
                  {{ suggestion }}
                  <i class="material-icons right grey-text text-darken-1">highlight_off</i>
                </span>
              </li>
            </ul>
          </div>
          <div v-if="selectOption === 'allInstances'">
            <p>All Instances</p>
          </div>
          <div v-if="selectOption === 'ThisInstance'">
            <p>This Instance</p>
          </div>
        </div>
      </div>
      <div class="right">
        <a class="red-text" style="margin-right: 2em" v-on:click="close">CANCEL</a>
        <a class="black-text text-darken-2" style="margin-right: 2em" v-on:click="save">SAVE</a>
      </div>
      <div class="teal-text text-lighten-2">{{ message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogInstanceView",
  data() {
    return {
      selectCheck: true,
      message: "",
      currInstance: null,
      tags: [],
      hiddenForInstance: [],
      visibleForInstance: [],
      listOfAllInstances: [],
      selectOption: "",
      addInstanceName: null,
      removeInstanceName: null,
      finalInstanceList:[],
    };
  },

  mounted() {
    this.getAllInstance("start")
      .then(() => {
        this.getHiddenInstance(this.$store.currentDialogIdForInstanceView)
          .then(() => {
            if (this.tags != null) {
              this.tags.forEach((element) => {
                if (element.includes("search_off_")) {
                  element = element.replace("search_off_", "");
                  if(this.listOfAllInstances.includes(element))
                    this.hiddenForInstance.push(element);
                }
              });
            }
            if (this.hiddenForInstance.length == 0) {
              this.visibleForInstance = this.listOfAllInstances;
              //this.selectOption = "allInstances";
              this.selectOption = "addInstance";
            }
            if (this.hiddenForInstance.length > 0) {
              this.visibleForInstance = this.listOfAllInstances.filter(
                (x) => !this.hiddenForInstance.includes(x)
              );
              if (
                this.visibleForInstance.length == 1 &&
                this.visibleForInstance[0] == this.currInstance
              ) {
                //this.selectOption = "ThisInstance";
                this.selectOption = "addInstance";
              } else {
                this.selectOption = "addInstance";
              }
            }
            this.finalInstanceList = this.visibleForInstance.slice()
          })
          .catch(() => this.toast("Could not get dialog search off instances"));
      })
      .catch(() => this.toast("Could not get list of instances"));
  },

  methods: {
    /**
     * Get list of all instances
     */
    getAllInstance(tag) {
      return new Promise((resolve, reject) => {
        this.$http.get("/dialogs?tag=" + tag).then(
          (response) => {
            response.data.forEach((element) => {
              this.listOfAllInstances.push(element.phrase);
            });
            resolve();
          },
          (response) => {
            reject(response);
          }
        );
      });
    },
    /**
     * Get list of instances not visible for dialog
     */
    getHiddenInstance(dialogID) {
      return new Promise((resolve, reject) => {
        this.$http.get("/dialogs/" + dialogID).then(
          (response) => {
            this.tags = response.data.tags;
            response.data.parent.forEach((element) => {
              if (element.includes("start_")) {
                this.currInstance = element.replace("start_", "");
              }
            });
            resolve();
          },
          (response) => {
            reject(response);
          }
        );
      });
    },
    /**
     * Remove instance name from visible instances list and add to list of hidden instance list on click
     */
    removeInstance(index, value) {
      if (this.selectCheck) {
        this.selectCheck = false;
        this.visibleForInstance.splice(index, 1);
        this.hiddenForInstance.push(value);
        this.removeInstanceName = value;
        this.addInstanceName = null;
      } else {
        M.toast({
          html: "Click Save to save changes",
        });
      }
    },
    /**
     * Remove instance name from hidden instances list and add to list of visible instance list on click
     */
    addInstance(index, value) {
      if (this.selectCheck) {
        this.selectCheck = false;
        this.hiddenForInstance.splice(index, 1);
        this.visibleForInstance.push(value);
        this.addInstanceName = value;
        this.removeInstanceName = null;
      } else {
        M.toast({
          html: "Click Save to save changes",
        });
      }
    },
    /**
     * close the pop-up view and send a emit event
     */
    close() {
      this.$root.$emit('CloseInstanceView', "close");
      this.$store.showDialogInstanceView = false;
    },
    /**
     * Add the changes to datastore by calling api on save button click
     */
    save() {
      //start :code for phase 3 search not implented yet
      if (this.selectOption == "ThisInstance") {
        this.$store.showDialogInstanceView = false;
        this.listOfAllInstances.forEach((element) => {
          if (
            element == this.currInstance &&
            !this.visibleForInstance.includes(element)
          ) {
            this.addInstanceApi(
              this.$store.currentDialogIdForInstanceView,
              this.currInstance
            )
              .then()
              .catch(() => this.toast("Could not update dialog"));
          }
          if (
            !this.hiddenForInstance.includes(element) &&
            element != this.currInstance
          ) {
            this.removeInstanceApi(
              this.$store.currentDialogIdForInstanceView,
              element
            )
              .then()
              .catch(() => this.toast("Could not update dialog"));
          }
        });
      }
      if (this.selectOption == "allInstances") {
        this.$store.showDialogInstanceView = false;
        this.hiddenForInstance.forEach((element) => {
          this.addInstanceApi(this.$store.currentDialogIdForInstanceView, element)
            .then()
            .catch(() => this.toast("Could not update dialog"));
        });
      }
      //end :code for phase 3 search not implented yet

      if (this.selectOption == "addInstance") {
        if (this.removeInstanceName) {
          this.message = "Saving changes...";
          this.removeInstanceApi(this.$store.currentDialogIdForInstanceView,this.removeInstanceName)
            .then((response) => {
              this.message = "";
              this.selectCheck = true;
              if (response.status == true) {
                M.toast({
                  html: "Changes saved",
                });
                 this.finalInstanceList = this.finalInstanceList.filter(x => x!=this.removeInstanceName)
              }
            })
            .catch(() =>
              this.toast(
                "Could not remove Instance name in dialog: " +
                  response.error_msg
              )
            );
        }
        if (this.addInstanceName) {
          this.message = "Saving changes...";
          this.addInstanceApi(this.$store.currentDialogIdForInstanceView,this.addInstanceName)
            .then((response) => {
              this.message = "";
              this.selectCheck = true;
              if (response.status == true) {
                M.toast({
                  html: "Changes saved",
                });
                this.finalInstanceList.push(this.addInstanceName)
              }
            })
            .catch(() =>
              this.toast(
                "Could not add Insatnce name in dialog: " + response.error_msg
              )
            );
        }
      }
    },
    /**
     * add search on for an instance in a dialog
     */
    addInstanceApi(dialogId, instanceName) {
      return new Promise((resolve, reject) => {
        this.$http
          .post("/search/instance/" + dialogId + "?instance=" + instanceName)
          .then(
            (response) => {
              resolve(response.data);
            },
            (response) => {
              reject(response);
            }
          );
      });
    },
    /**
     * add search off for and instance in a dialog
     */
    removeInstanceApi(dialogId, instanceName) {
      return new Promise((resolve, reject) => {
        this.$http
          .delete("/search/instance/" + dialogId + "?instance=" + instanceName)
          .then(
            (response) => {
              resolve(response.data);
            },
            (response) => {
              reject(response);
            }
          );
      });
    },
  },
};
</script>

<style scoped>
.suggestion-list-add {
  margin: 10px;
  text-decoration: underline;
}
.suggestion-list-remove {
  display: grid;
  grid-template-columns: 1fr;
  margin: 10px;
  /* border-radius: 5px; */
}
.add-box {
  border-radius: 15px;
  border: 1px solid #dad3d3;
  padding: 2px 5px 2px 5px;
  margin: 2px;
}
span.add-hover:hover {
  cursor: pointer;
  color: #26a69a;
}
span.add-box:hover {
  cursor: pointer;
  color: #26a69a;
}
.seperator {
  height: 85%;
  width: 1px;
  background: grey;
  top: 30px;
  bottom: 0;
  position: absolute;
  left: 58%;
}

.overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  cursor: initial;
}
.upload-image-wrapper {
  box-shadow: 2px 2px 3px #888;
  left: calc(50% - 250px);
  top: calc(50% - 250px);
  margin: -8px;
  width: 30px;
  position: fixed;
  padding: 10px;
  text-align: center;
  align-content: center;
  color: dimgray;
  background: #f7f7f7;
  z-index: 10;
  animation: grow 0.25s;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 5px;
  top: 0px;
}
.close button {
  background: none;
  border: 0px;
  font-weight: 600;
}
button:hover{
cursor:pointer;
color: red;
}
a:hover {
  cursor: pointer;
  text-decoration: underline;
}
.upload-image-head,
.update-image-head {
  padding: 10px;
  font-size: 22px;
}
</style>